import React, {Component} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faFacebookSquare} from "@fortawesome/free-brands-svg-icons";

export default class PageFooter extends Component{
    getCurrentYear(){
        return new Date().getFullYear()
    }

    render() {
        return <footer style={{
            "color": "#9A9A9A",
        }}>
            <div className="section text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                        </div>
                        <div className="col" style={{
                            "textAlign": "right",
                        }}>
                            Copyright © {this.getCurrentYear()} Chuang Xing Manufacturing Co. Ltd. All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    }
}